<template>
  <div class="dial-modal" :style="dialStyle" v-clickoutside="closeDial">
    <ul class="phone-list">
      <li class="item" v-for="item in phoneList" @click="duyanCall(item.phoneNum)">
        <span class="label">{{item.name}}</span>
        <span class="phone-number">{{item.telNum}}</span>
        <i class="web-icon-callout"></i>
      </li>
    </ul>
    <div class="dial-arrow"></div>
  </div>
</template>

<script>
import Clickoutside from 'element-ui/lib/utils/clickoutside'

export default {

  name: 'dial-modal',

  props: {
    dialStyle: {
      type: Object,
      required: true
    },
    phoneList: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
    }
  },

  methods: {

    // 调用CTI进行呼出
    duyanCall (phone) {
      window.CALL_CENTER.callme(phone)
    },

    // 关闭拨号弹层
    closeDial () {
      this.$emit('closeModal')
    }
  },
  directives: { Clickoutside }
}
</script>

<style lang="less" scoped>
  @import '../../assets/less/variable.less';

  .dial-modal {
    width: 200px;
    z-index: 2010;
    position: fixed;
    display: block;
    background-color: #fff;
    border-radius: 2px;
    border: 1px solid rgb(209, 219, 229);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .12), 0px 0px 6px 0px rgba(0, 0, 0, .04);
    font-size: 12px;
    .phone-list {
      .item {
        display: flex;
        padding: 0 10px;
        line-height: 30px;
        cursor: pointer;
        &:hover {
          background-color: #f5f9ff;
        }
        .phone-number {
          color: @primary;
        }
        .label, .phone-number {
          display: inline-block;
          flex: 1 1 auto;
        }
        .web-icon-callout {
          color: #58B957;
          font-size: 14px;
          flex: 0 0 auto;
          line-height: 30px;
        }
      }
    }
    .dial-arrow, .dial-arrow::after{
      display: block;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
      position: absolute;
    }
    .dial-arrow {
      top: 10px;
      left: -6px;
      margin-bottom: 3px;
      border-right-color: rgb(209, 219, 229);
      border-width: 6px;
      border-left-width: 0;
      &:after {
        content: "";
        border-width: 6px;
        bottom: -6px;
        left: 1px;
        border-right-color: #fff;
        border-left-width: 0;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// dial-modal.vue?62b21ce9